import apiProxy from './api-proxy-inst';

class ErpApi {
  adminErpList(args) {
    return apiProxy.request('/erpapp_inst/list', args).then(data => {
      return data;
    });
  }

  adminErpCount(args) {
    return apiProxy.request('/erpapp_inst/count', args).then(data => {
      return data;
    });
  }
}

export default new ErpApi();